(function () {
    angular
        .module('smartertoolsApp')
        .controller('downloadsModalController', ['$scope', downloadsModalController]);

    function downloadsModalController($scope) {
        const vm = this;
        vm.page = 'downloads';

        // Functions
        vm.getManualUrl = getManualUrl;
        vm.parseUrl = parseUrl;
        vm.showManual = showManual;
        vm.showDownloads = showDownloads;

        // -----------------------------------------------

        function getManualUrl() {
            if (!vm.Items)
                return '';

            for (let i = 0; i < vm.Items.length; i++) {
                if (vm.Items[i].Name.indexOf('Manual') >= 0)
                    return parseUrl(vm.Items[i].DownloadLink);
            }

            return '';
        }

        function parseUrl(url) {
            if (!url) return url;
            return url.indexOf('http') === 0
                ? url
                : url.indexOf('/') === 0
                    ? `https://downloads.smartertools.com${url}`
                    : `https://downloads.smartertools.com/${url}`;
        }

        function showManual() {
            vm.page = 'manual';
            $scope.$applyAsync();
        }

        function showDownloads(dlText, dlJson) {
            if (dlText) {
                vm.Title = ` - ${dlText}`;
                vm.Items = dlJson;
                bootstrap.Modal.getOrCreateInstance(document.getElementById('downloads-modal')).show();
            }

            vm.page = 'downloads';
            $scope.$applyAsync();
        }
    }

})();